// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import call from './call'

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  call
})

export default rootReducer
